export type EraId = "all" | "ultra" | "modern" | "mid" | "vintage";

export type EraReturnSeries = {
  id: EraId;
  label: string;
  range: string;
  cohortSize: number;
  psa10Returns: readonly number[];
};

export const PSA10_PERIOD_START: string = "2026-01-24";
export const PSA10_PERIOD_END: string = "2026-07-24";

// Static snapshot copied from the completed pricing analysis. This page makes no
// database or pricing-service requests at runtime. Returns are percentage points
// normalized to 0% on the first day.
export const PSA10_DATES: readonly string[] = [
  "2026-01-24",
  "2026-01-25",
  "2026-01-26",
  "2026-01-27",
  "2026-01-28",
  "2026-01-29",
  "2026-01-30",
  "2026-01-31",
  "2026-02-01",
  "2026-02-02",
  "2026-02-03",
  "2026-02-04",
  "2026-02-05",
  "2026-02-06",
  "2026-02-07",
  "2026-02-08",
  "2026-02-09",
  "2026-02-10",
  "2026-02-11",
  "2026-02-12",
  "2026-02-13",
  "2026-02-14",
  "2026-02-15",
  "2026-02-16",
  "2026-02-17",
  "2026-02-18",
  "2026-02-19",
  "2026-02-20",
  "2026-02-21",
  "2026-02-22",
  "2026-02-23",
  "2026-02-24",
  "2026-02-25",
  "2026-02-26",
  "2026-02-27",
  "2026-02-28",
  "2026-03-01",
  "2026-03-02",
  "2026-03-03",
  "2026-03-04",
  "2026-03-05",
  "2026-03-06",
  "2026-03-07",
  "2026-03-08",
  "2026-03-09",
  "2026-03-10",
  "2026-03-11",
  "2026-03-12",
  "2026-03-13",
  "2026-03-14",
  "2026-03-15",
  "2026-03-16",
  "2026-03-17",
  "2026-03-18",
  "2026-03-19",
  "2026-03-20",
  "2026-03-21",
  "2026-03-22",
  "2026-03-23",
  "2026-03-24",
  "2026-03-25",
  "2026-03-26",
  "2026-03-27",
  "2026-03-28",
  "2026-03-29",
  "2026-03-30",
  "2026-03-31",
  "2026-04-01",
  "2026-04-02",
  "2026-04-03",
  "2026-04-04",
  "2026-04-05",
  "2026-04-06",
  "2026-04-07",
  "2026-04-08",
  "2026-04-09",
  "2026-04-10",
  "2026-04-11",
  "2026-04-12",
  "2026-04-13",
  "2026-04-14",
  "2026-04-15",
  "2026-04-16",
  "2026-04-17",
  "2026-04-18",
  "2026-04-19",
  "2026-04-20",
  "2026-04-21",
  "2026-04-22",
  "2026-04-23",
  "2026-04-24",
  "2026-04-25",
  "2026-04-26",
  "2026-04-27",
  "2026-04-28",
  "2026-04-29",
  "2026-04-30",
  "2026-05-01",
  "2026-05-02",
  "2026-05-03",
  "2026-05-04",
  "2026-05-05",
  "2026-05-06",
  "2026-05-07",
  "2026-05-08",
  "2026-05-09",
  "2026-05-10",
  "2026-05-11",
  "2026-05-12",
  "2026-05-13",
  "2026-05-14",
  "2026-05-15",
  "2026-05-16",
  "2026-05-17",
  "2026-05-18",
  "2026-05-19",
  "2026-05-20",
  "2026-05-21",
  "2026-05-22",
  "2026-05-23",
  "2026-05-24",
  "2026-05-25",
  "2026-05-26",
  "2026-05-27",
  "2026-05-28",
  "2026-05-29",
  "2026-05-30",
  "2026-05-31",
  "2026-06-01",
  "2026-06-02",
  "2026-06-03",
  "2026-06-04",
  "2026-06-05",
  "2026-06-06",
  "2026-06-07",
  "2026-06-08",
  "2026-06-09",
  "2026-06-10",
  "2026-06-11",
  "2026-06-12",
  "2026-06-13",
  "2026-06-14",
  "2026-06-15",
  "2026-06-16",
  "2026-06-17",
  "2026-06-18",
  "2026-06-19",
  "2026-06-20",
  "2026-06-21",
  "2026-06-22",
  "2026-06-23",
  "2026-06-24",
  "2026-06-25",
  "2026-06-26",
  "2026-06-27",
  "2026-06-28",
  "2026-06-29",
  "2026-06-30",
  "2026-07-01",
  "2026-07-02",
  "2026-07-03",
  "2026-07-04",
  "2026-07-05",
  "2026-07-06",
  "2026-07-07",
  "2026-07-08",
  "2026-07-09",
  "2026-07-10",
  "2026-07-11",
  "2026-07-12",
  "2026-07-13",
  "2026-07-14",
  "2026-07-15",
  "2026-07-16",
  "2026-07-17",
  "2026-07-18",
  "2026-07-19",
  "2026-07-20",
  "2026-07-21",
  "2026-07-22",
  "2026-07-23",
  "2026-07-24",
];

export const SP500_RETURNS: readonly number[] = [
  0,
  0,
  0.5006,
  0.9108,
  0.9026,
  0.7722,
  0.3387,
  0.3387,
  0.3387,
  0.8796,
  0.0318,
  -0.4756,
  -1.6949,
  0.2413,
  0.2413,
  0.2413,
  0.7116,
  0.3789,
  0.3739,
  -1.198,
  -1.1487,
  -1.1487,
  -1.1487,
  -1.1487,
  -1.0468,
  -0.496,
  -0.7768,
  -0.0882,
  -0.0882,
  -0.0882,
  -1.1259,
  -0.3693,
  0.4413,
  -0.0976,
  -0.5311,
  -0.5311,
  -0.5311,
  -0.4915,
  -1.4313,
  -0.6668,
  -1.2277,
  -2.539,
  -2.539,
  -2.539,
  -1.7297,
  -1.9395,
  -2.0217,
  -3.5136,
  -4.0983,
  -4.0983,
  -4.0983,
  -3.1267,
  -2.8851,
  -4.2066,
  -4.4699,
  -5.916,
  -5.916,
  -5.916,
  -4.8385,
  -5.1946,
  -4.6809,
  -6.34,
  -7.9062,
  -7.9062,
  -7.9062,
  -8.2696,
  -5.5973,
  -4.9206,
  -4.814,
  -4.814,
  -4.814,
  -4.814,
  -4.3927,
  -4.3201,
  -1.9203,
  -1.3151,
  -1.4275,
  -1.4275,
  -1.4275,
  -0.4247,
  0.7486,
  1.5521,
  1.8172,
  3.0431,
  3.0431,
  3.0431,
  2.7985,
  2.1459,
  3.2143,
  2.7878,
  3.6073,
  3.6073,
  3.6073,
  3.735,
  3.2273,
  3.1861,
  4.2426,
  4.5478,
  4.5478,
  4.5478,
  4.1231,
  4.9686,
  6.4999,
  6.0949,
  6.9888,
  6.9888,
  6.9888,
  7.19,
  7.0182,
  7.6442,
  8.4682,
  7.1272,
  7.1272,
  7.1272,
  7.0484,
  6.3335,
  7.481,
  7.6654,
  8.0667,
  8.0667,
  8.0667,
  8.0667,
  8.7268,
  8.7447,
  9.3704,
  9.608,
  9.608,
  9.608,
  9.8957,
  10.0377,
  9.2265,
  9.6694,
  6.7692,
  6.7692,
  6.7692,
  7.0872,
  6.8113,
  5.081,
  6.9219,
  7.4592,
  7.4592,
  7.4592,
  9.2353,
  8.6144,
  7.2949,
  8.4587,
  8.4587,
  8.4587,
  8.4587,
  8.0568,
  6.5048,
  6.4002,
  6.3896,
  6.3394,
  6.3394,
  6.3394,
  7.5889,
  8.441,
  8.2078,
  8.208,
  8.208,
  8.208,
  8.208,
  8.9915,
  8.506,
  8.2003,
  9.0813,
  9.5404,
  9.5404,
  9.5404,
  8.6721,
  9.0806,
  9.4972,
  8.9386,
  7.8385,
  7.8385,
  7.8385,
  7.6301,
  8.5833,
  8.4353,
  7.1243,
  7.1243,
];

export const PSA10_ERA_SERIES: readonly EraReturnSeries[] = [
  {
    id: "all",
    label: "All",
    range: "1999 or later",
    cohortSize: 26_779,
    psa10Returns: [
      0,
      0.0038,
      0.0308,
      0.089,
      0.178,
      0.178,
      0.178,
      0.178,
      0.488,
      0.6068,
      0.7208,
      0.7858,
      1.0277,
      1.1222,
      1.2931,
      1.4129,
      1.4594,
      1.487,
      1.6205,
      1.7109,
      1.7403,
      1.7913,
      1.8721,
      1.9143,
      2.1074,
      2.2562,
      2.6042,
      2.8125,
      2.9912,
      2.9044,
      2.9937,
      3.0783,
      3.2298,
      3.4743,
      3.5852,
      3.6313,
      3.8714,
      4.0325,
      4.2425,
      4.4195,
      4.7299,
      5.345,
      5.551,
      5.8622,
      6.0834,
      6.6867,
      7.5917,
      7.7174,
      8.3048,
      8.5609,
      8.7386,
      8.3786,
      8.7941,
      9.0795,
      9.1412,
      9.5156,
      9.6955,
      9.9128,
      10.2703,
      10.7335,
      11.0148,
      11.0148,
      11.0148,
      11.4592,
      12.2146,
      12.5141,
      12.7623,
      13.2908,
      13.6698,
      14.2388,
      15.0122,
      15.3869,
      15.7982,
      16.1969,
      16.5599,
      17.0374,
      17.1299,
      17.42,
      17.6663,
      17.9767,
      17.889,
      18.4184,
      18.7799,
      19.0798,
      19.8724,
      20.23,
      20.4043,
      20.4043,
      20.4043,
      20.4043,
      20.4043,
      20.4043,
      20.4043,
      20.4043,
      20.4043,
      20.4043,
      22.5483,
      22.6998,
      23.475,
      23.7904,
      24.4269,
      24.6675,
      24.6675,
      24.9226,
      25.0345,
      25.324,
      25.7731,
      26.0805,
      26.4181,
      26.8812,
      27.3936,
      27.743,
      28.1874,
      28.5008,
      28.7723,
      29.133,
      29.3635,
      29.6944,
      29.9965,
      30.6665,
      30.8564,
      31.3443,
      31.5659,
      31.9319,
      32.5969,
      32.9788,
      33.5033,
      33.992,
      34.37,
      34.6354,
      35.045,
      35.1725,
      35.3416,
      35.3091,
      35.5181,
      35.787,
      36.187,
      36.4978,
      37.1046,
      37.5716,
      37.9407,
      38.4165,
      38.6895,
      38.7213,
      39.028,
      39.4657,
      39.8682,
      40.1475,
      40.7008,
      41.0208,
      41.6857,
      42.093,
      42.3025,
      42.5453,
      42.898,
      43.1203,
      43.7736,
      44.1549,
      44.4195,
      44.3062,
      44.6893,
      44.994,
      45.4095,
      45.4133,
      45.6573,
      46.3726,
      46.9853,
      47.7795,
      48.258,
      48.8813,
      49.137,
      50.2621,
      50.5838,
      51.7294,
      52.1095,
      52.4206,
      52.7683,
      53.0902,
      53.777,
      54.2248,
      54.5964,
      55.0595,
    ],
  },
  {
    id: "ultra",
    label: "Ultra-modern",
    range: "2019+",
    cohortSize: 12_263,
    psa10Returns: [
      0,
      -0.0628,
      -0.0723,
      -0.0663,
      -0.0313,
      -0.0313,
      -0.0313,
      -0.0313,
      0.2177,
      0.382,
      0.4837,
      0.5165,
      0.9005,
      1.0044,
      1.142,
      1.1179,
      1.055,
      0.9614,
      0.9917,
      1.0094,
      0.9778,
      0.93,
      0.9577,
      0.9456,
      0.9769,
      0.9954,
      1.0227,
      1.1265,
      1.1369,
      0.7486,
      0.7992,
      0.8338,
      0.9408,
      0.9733,
      1.0328,
      1.1053,
      1.177,
      1.3169,
      1.444,
      1.4883,
      1.6664,
      1.8057,
      1.8716,
      1.9598,
      2.0224,
      2.8782,
      3.1965,
      3.3446,
      3.8596,
      4.0085,
      4.0698,
      3.496,
      3.6694,
      3.8152,
      3.8923,
      4.0044,
      4.1745,
      4.2235,
      4.3155,
      4.4566,
      4.4822,
      4.4822,
      4.4822,
      4.1492,
      4.2392,
      4.3834,
      4.4727,
      4.6832,
      4.9859,
      5.325,
      5.4792,
      5.5867,
      5.566,
      5.8049,
      6.0016,
      6.1102,
      6.2677,
      6.3705,
      6.5137,
      6.8195,
      6.9734,
      7.2013,
      7.3121,
      7.4652,
      7.6712,
      7.7338,
      7.8938,
      7.8938,
      7.8938,
      7.8938,
      7.8938,
      7.8938,
      7.8938,
      7.8938,
      7.8938,
      7.8938,
      9.2555,
      9.359,
      9.8235,
      9.946,
      10.7163,
      10.8973,
      10.8973,
      11.1088,
      11.2652,
      11.4177,
      11.6351,
      11.8344,
      11.9519,
      12.1733,
      12.3944,
      12.5185,
      12.7553,
      12.8785,
      12.9445,
      13.2268,
      13.4628,
      13.628,
      13.7726,
      13.9622,
      14.059,
      14.1109,
      14.2136,
      14.5718,
      14.8574,
      15.1482,
      15.4533,
      15.6582,
      15.7617,
      15.9534,
      16.2582,
      16.3926,
      16.5284,
      16.7171,
      16.8591,
      17.2927,
      17.6124,
      17.8336,
      18.2461,
      18.5408,
      18.6053,
      18.7667,
      18.9617,
      19.1585,
      19.4665,
      19.7207,
      19.8905,
      20.02,
      20.5819,
      20.8336,
      21.1634,
      21.4086,
      21.4945,
      21.6516,
      21.7386,
      21.8199,
      22.0491,
      22.2763,
      22.3998,
      22.4765,
      22.554,
      22.6432,
      23.0451,
      23.3893,
      23.4504,
      23.465,
      23.6368,
      23.7254,
      23.7869,
      23.9683,
      24.1128,
      24.2008,
      24.5594,
      25.1447,
      25.2852,
      25.4143,
      25.582,
      25.3445,
      25.6182,
      25.8036,
      26.0028,
      26.2479,
    ],
  },
  {
    id: "modern",
    label: "Modern",
    range: "2014–2019",
    cohortSize: 6_470,
    psa10Returns: [
      0,
      0.0627,
      0.0528,
      0.0828,
      0.1085,
      0.1085,
      0.1085,
      0.1085,
      0.2031,
      0.3551,
      0.396,
      0.4914,
      0.5242,
      0.486,
      0.5285,
      0.5868,
      0.771,
      0.7752,
      0.834,
      0.9514,
      0.9469,
      0.9905,
      1.0052,
      1.0418,
      1.2193,
      1.2629,
      1.2945,
      1.3928,
      1.4212,
      1.4699,
      1.5241,
      1.5537,
      1.6239,
      1.6869,
      1.7402,
      1.7614,
      1.8288,
      1.9115,
      2.0004,
      2.1277,
      2.5321,
      4.2502,
      4.4321,
      4.6452,
      5.0028,
      5.4556,
      5.5909,
      6.3789,
      6.6191,
      6.9481,
      6.9944,
      6.176,
      6.3401,
      6.6241,
      6.3739,
      6.5596,
      6.7857,
      6.8925,
      7.4385,
      7.6481,
      7.8241,
      7.8241,
      7.8241,
      8.1797,
      8.3013,
      8.5736,
      8.6094,
      8.6412,
      8.5534,
      8.9602,
      9.2079,
      9.775,
      10.1102,
      10.1113,
      10.2605,
      10.5016,
      10.5264,
      10.7786,
      11.2334,
      11.3303,
      11.5744,
      11.867,
      12.2482,
      12.4233,
      12.5299,
      12.8154,
      12.8822,
      12.8822,
      12.8822,
      12.8822,
      12.8822,
      12.8822,
      12.8822,
      12.8822,
      12.8822,
      12.8822,
      14.5531,
      14.6215,
      14.7147,
      14.9009,
      14.9283,
      15.1046,
      15.1046,
      15.6735,
      15.7815,
      15.9017,
      16.1375,
      16.2931,
      16.4832,
      16.6561,
      16.7965,
      17.177,
      17.7976,
      17.9444,
      18.151,
      18.6128,
      18.5689,
      18.6238,
      18.7193,
      19.1819,
      19.5256,
      19.6716,
      19.7621,
      20.0005,
      20.0854,
      20.4115,
      21.179,
      21.33,
      21.4062,
      21.3903,
      21.6152,
      21.7252,
      22.0574,
      22.2645,
      22.4327,
      22.9543,
      23.2623,
      23.3552,
      23.7018,
      24.2682,
      24.6549,
      25.2874,
      25.5061,
      25.8033,
      26.0422,
      26.256,
      26.3449,
      26.436,
      26.6202,
      26.6754,
      27.346,
      27.7895,
      27.8776,
      28.0913,
      28.2329,
      28.5247,
      28.7595,
      28.6751,
      28.8321,
      29.0237,
      29.253,
      29.5321,
      29.64,
      29.7389,
      29.7852,
      29.91,
      30.0853,
      30.7682,
      30.8651,
      31.2083,
      31.237,
      31.743,
      31.9252,
      32.1243,
      32.3165,
      32.7601,
      33.3976,
      33.8325,
      34.1877,
      34.4536,
      34.9554,
      35.17,
    ],
  },
  {
    id: "mid",
    label: "Mid-era",
    range: "2007–2013",
    cohortSize: 4_216,
    psa10Returns: [
      0,
      0.0275,
      0.0735,
      0.1338,
      0.2608,
      0.2608,
      0.2608,
      0.2608,
      0.4556,
      0.5486,
      0.528,
      0.5397,
      0.6656,
      0.7625,
      0.9182,
      0.9961,
      0.974,
      1.0592,
      1.2327,
      1.292,
      1.4109,
      1.4944,
      1.5908,
      1.6126,
      1.8873,
      1.8735,
      3.4448,
      3.5405,
      4.2285,
      4.3796,
      4.4204,
      4.6018,
      4.914,
      5.0786,
      5.1222,
      5.1177,
      5.7787,
      5.8523,
      6.4784,
      6.4803,
      6.7173,
      6.9214,
      7.0637,
      8.1491,
      8.3263,
      8.6917,
      12.5294,
      11.4009,
      12.4502,
      12.6253,
      12.9616,
      13.4305,
      14.5365,
      14.7902,
      14.8523,
      15.6659,
      15.8159,
      16.2379,
      16.6847,
      18.2128,
      19.0598,
      19.0598,
      19.0598,
      19.8308,
      22.6889,
      23.1951,
      23.3784,
      24.908,
      25.0707,
      25.3519,
      25.7005,
      25.6687,
      26.136,
      26.9627,
      27.2783,
      27.956,
      25.5263,
      25.8797,
      26.2021,
      26.2889,
      23.5304,
      23.7124,
      24.3285,
      24.4319,
      25.9746,
      26.3994,
      26.1868,
      26.1868,
      26.1868,
      26.1868,
      26.1868,
      26.1868,
      26.1868,
      26.1868,
      26.1868,
      26.1868,
      28.3142,
      28.6646,
      30.2708,
      30.286,
      30.8028,
      30.9259,
      30.9259,
      31.2568,
      31.3547,
      31.4979,
      31.6865,
      32.4116,
      32.6105,
      33.3275,
      33.9111,
      34.3939,
      34.5624,
      34.8182,
      35.0516,
      35.6203,
      35.6996,
      36.0871,
      36.409,
      38.0278,
      38.1037,
      39.0952,
      39.249,
      39.5008,
      38.7678,
      39.2175,
      39.5511,
      40.5412,
      40.6777,
      40.9124,
      41.2371,
      41.3221,
      41.4108,
      41.5514,
      41.5913,
      41.8798,
      42.0267,
      41.8009,
      42.3355,
      42.5786,
      42.693,
      43.3658,
      43.5555,
      43.6197,
      43.8651,
      44.2529,
      44.4939,
      45.2526,
      45.5946,
      45.9579,
      47.0497,
      47.2928,
      47.6901,
      47.7685,
      47.9989,
      48.1359,
      49.5759,
      50.1942,
      50.346,
      48.9537,
      49.3748,
      49.704,
      49.6646,
      49.8504,
      50.048,
      51.5875,
      51.9784,
      54.0257,
      56.0059,
      57.7041,
      57.82,
      59.9754,
      60.373,
      60.4763,
      60.9556,
      61.3795,
      61.5249,
      62.5729,
      64.7537,
      65.2055,
      65.6209,
      66.8226,
    ],
  },
  {
    id: "vintage",
    label: "Vintage",
    range: "1999–2006",
    cohortSize: 5_561,
    psa10Returns: [
      0,
      0.1163,
      0.2419,
      0.435,
      0.6786,
      0.6786,
      0.6786,
      0.6786,
      1.3752,
      1.5109,
      1.7905,
      1.9628,
      2.1559,
      2.3541,
      2.7561,
      3.2707,
      3.4435,
      3.7225,
      4.0842,
      4.2907,
      4.4193,
      4.6436,
      4.8818,
      5.0659,
      5.556,
      6.2134,
      6.6158,
      7.219,
      7.5063,
      7.7811,
      8.0298,
      8.1831,
      8.3637,
      9.2655,
      9.5759,
      9.6232,
      10.0511,
      10.5044,
      10.7268,
      11.3703,
      11.9113,
      12.5074,
      13.0761,
      13.3269,
      13.717,
      14.1678,
      14.8236,
      15.2501,
      15.9512,
      16.4971,
      16.9241,
      17.2723,
      17.8974,
      18.486,
      18.8947,
      19.6444,
      19.9496,
      20.4838,
      21.181,
      21.8764,
      22.327,
      22.327,
      22.327,
      24.2306,
      25.4112,
      25.9183,
      26.76,
      27.6681,
      28.8284,
      30.483,
      33.3839,
      34.3649,
      35.6888,
      36.4555,
      37.3735,
      38.6672,
      40.614,
      41.2728,
      41.5018,
      42.1782,
      43.247,
      44.9136,
      45.5339,
      46.4572,
      48.5456,
      49.5032,
      50.1081,
      50.1081,
      50.1081,
      50.1081,
      50.1081,
      50.1081,
      50.1081,
      50.1081,
      50.1081,
      50.1081,
      54.316,
      54.4679,
      55.8564,
      56.923,
      57.8924,
      58.4272,
      58.4272,
      58.3376,
      58.3876,
      59.2498,
      60.5595,
      60.9397,
      61.9974,
      63.0329,
      64.4636,
      65.126,
      65.965,
      66.8877,
      67.6987,
      68.1082,
      68.7631,
      69.658,
      70.4572,
      71.455,
      71.7682,
      73.1529,
      73.8346,
      74.4258,
      77.4774,
      78.0947,
      78.9852,
      80.0046,
      81.4266,
      82.0838,
      82.9286,
      83.1507,
      83.3062,
      82.4586,
      82.9775,
      82.8492,
      83.6823,
      84.7695,
      86.0691,
      86.933,
      88.056,
      88.7924,
      89.3417,
      88.7144,
      89.1446,
      90.2331,
      91.5154,
      91.9343,
      92.9433,
      93.6308,
      94.7476,
      95.6351,
      96.0707,
      96.7298,
      97.9942,
      98.5005,
      99.9118,
      100.9255,
      101.655,
      101.7991,
      102.9836,
      103.7252,
      104.8314,
      104.2265,
      105.086,
      107.2241,
      109.3566,
      110.6585,
      111.1553,
      112.0941,
      112.8974,
      115.9267,
      116.2088,
      120.2685,
      121.2858,
      121.6712,
      122.1574,
      123.0856,
      123.8354,
      125.0701,
      125.5735,
      126.2167,
    ],
  },
];
